import React from 'react'
import PropTypes from 'prop-types'
import List from '@material-ui/core/List'
import CheckboxItem from './CheckboxItem'

const ListOfCheckboxes=props=>{
    return (
        <div>
            <List disablePadding={true}>
                {props.answers.map(answer=>{
                    return (
                       <CheckboxItem 
                       key={answer.field} field={answer.field} 
                       label={answer.label} subQuestion={answer.subQuestion} 
                       subAnswers={answer.subAnswers} 
                       changeFieldValue={props.changeFieldValue} />
                    )
                })}
            </List>
        </div>    
    )
}

ListOfCheckboxes.propTypes = {
    answers: PropTypes.array
}

export default ListOfCheckboxes


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/ListOfCheckboxes.js